/**
 * В dev подменяет публичный URL reg.ru S3 на путь `/s3-regru/...`, который проксирует Vite
 * на тот же хост (`localhost`). Так браузер и расширения не ходят на чужой origin — меньше
 * ошибок CORS при hover/preview. В production возвращаем URL без изменений (на бакете нужен
 * CORS под ваш домен, если отображаете файлы с другого сайта).
 */
export function devProxyS3Url(url: string | null | undefined): string {
  if (url == null) return '';
  const s = String(url).trim();
  if (s === '') return '';
  if (import.meta.env.PROD) return s;
  try {
    const u = new URL(s);
    if (u.hostname === 's3.regru.cloud') {
      return `/s3-regru${u.pathname}${u.search}${u.hash}`;
    }
  } catch {
    return s;
  }
  return s;
}
